import styled from "styled-components";
import {Text} from "./Shared";
import {useState, ChangeEvent} from "react";
import {solease_lightblue} from "../../constants/Colors";

const Wrapper = styled.div`
  margin-top: -20px;
  margin-bottom: 25px;

  input[type="file"] {
    display: none;
  }

  ${Text}{
    margin: 5px 0;
  }
`

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    margin-right: 6px;
  }
`

const FilenamesWrapper = styled.div`
  ${Text}{
    color: ${solease_lightblue};
    margin: 0;
  }
`

const plusIcon = require('../../assets/icons/plus.svg').default

const FileInput = () => {
    const [fileNames, setFileNames] = useState<string[]>([])

    const onFileInputChange = (e : ChangeEvent<HTMLInputElement>) => {
        if(e.target.files){
            setFileNames(Object.values(e.target.files).map((file: {name: string}) => file.name))
        }
    }

    return (
        <Wrapper>
            <Text small>Indien nodig kan je hieronder relevante documenten toevoegen:</Text>
            <Label>
                <input type="file" multiple onChange={onFileInputChange}/>
                <img src={plusIcon} alt=''/>
                <Text small>Bestanden toevoegen</Text>
            </Label>
            {
                fileNames.map((fileName, index) => <FilenamesWrapper key={index}>
                    <Text small>{fileName}</Text>
                </FilenamesWrapper>)
            }
        </Wrapper>
    )
}

export default FileInput
